import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import moment from 'moment'
import 'moment/locale/es'

import { getCallLogs } from '../services'
import { handleError } from '../../../helpers'

export default function CustomerCallLogsHistory({ customerId }) {
	const [callLogs, setCallLogs] = useState(null)

	useEffect(() => {
		getCallLogs({
			'filter[customer_id]': customerId,
			sort: '-created_at',
			per_page: 20,
		})
			.then(res => setCallLogs(res.data.data))
			.catch(error => handleError(error))
	}, [ customerId ])

	return (
		<div className='mt-3 pt-3' style={{ borderTop: '1px solid #dee2e6' }}>
			<p className='bold mb-2'>Historial de llamadas</p>
			{ !callLogs ? (
				<Spinner animation='border' size='sm' />
			) : callLogs.length === 0 ? (
				<p className='text-muted small mb-0'>No hay llamadas previas a este cliente.</p>
			) : (
				<div style={{ maxHeight: '220px', overflowY: 'auto' }}>
					{ callLogs.map(log => (
						<div key={log.id} className='mb-2 pb-2' style={{ borderBottom: '1px solid #f0f0f0' }}>
							<small className='text-muted'>
								{moment(log.created_at).format('DD-MM-YYYY hh:mm A')}
								{ log.outcome ? ` · ${log.outcome}` : '' }
							</small>
							<p className='mb-0'>{log.comment || <em className='text-muted'>Sin comentario</em>}</p>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
